const sandovalTeamIcon =

<svg className="sandovalIcon" version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="750.000000pt" height="300.000000pt" viewBox="0 0 750.000000 300.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M3050 2515 c0 -12 14 -15 70 -15 l70 0 0 -185 c0 -178 1 -185 20
-185 19 0 20 7 20 185 l0 185 70 0 c56 0 70 3 70 15 0 13 -24 15 -160 15 -136
0 -160 -2 -160 -15z"/>
<path d="M3550 2330 c0 -193 1 -200 20 -200 19 0 20 7 20 95 l0 95 120 0 120
0 0 -95 c0 -78 3 -95 15 -95 13 0 15 29 15 200 0 171 -2 200 -15 200 -12 0
-15 -17 -15 -90 l0 -90 -120 0 -120 0 0 90 c0 83 -1 90 -20 90 -19 0 -20 -7
-20 -200z"/>
<path d="M4090 2330 l0 -200 130 0 c109 0 130 2 130 15 0 12 -19 15 -115 15
l-115 0 0 80 0 80 100 0 c82 0 100 3 100 15 0 12 -18 15 -100 15 l-100 0 0 75
0 75 115 0 c96 0 115 3 115 15 0 13 -21 15 -130 15 l-130 0 0 -200z"/>
<path d="M660 2310 l0 -70 975 0 975 0 0 70 0 70 -975 0 -975 0 0 -70z"/>
<path d="M4760 2310 l0 -70 1060 0 1060 0 0 70 0 70 -1060 0 -1060 0 0 -70z"/>
<path d="M813 1876 c-100 -32 -148 -100 -141 -198 7 -94 49 -126 228 -173 133
-34 176 -56 197 -99 75 -158 -206 -236 -385 -106 l-40 28 -13 -25 c-12 -23
-11 -27 11 -46 14 -11 50 -31 80 -45 66 -31 193 -41 277 -23 168 38 205 250
56 324 -26 13 -97 36 -158 51 -131 33 -171 54 -184 102 -18 64 16 128 82 153
71 27 215 5 263 -40 l22 -21 18 26 c16 26 16 27 -2 41 -10 8 -39 24 -64 36
-56 28 -185 35 -247 15z"/>
<path d="M1501 1548 c-79 -189 -146 -349 -148 -355 -4 -9 6 -13 30 -13 l34 0
44 108 44 107 164 0 164 0 45 -107 c44 -108 45 -108 79 -108 19 0 33 4 31 8
-1 5 -68 165 -147 355 -138 334 -145 347 -171 347 -25 0 -32 -14 -169 -342z
m238 95 c35 -86 66 -165 69 -175 4 -17 -5 -18 -137 -18 -102 0 -141 3 -141 12
0 16 133 338 140 338 3 0 34 -71 69 -157z"/>
<path d="M2220 1535 l0 -355 30 0 30 0 0 285 c0 157 4 285 8 285 5 0 111 -128
235 -285 207 -260 230 -285 257 -285 l30 0 -2 353 -3 352 -32 3 -33 3 -2 -295
-3 -296 -234 295 c-187 236 -239 295 -258 295 l-23 0 0 -355z"/>
<path d="M3110 1534 l0 -356 163 4 c148 3 167 6 217 29 79 37 115 71 152 147
31 63 33 72 33 177 0 98 -3 116 -26 165 -69 147 -164 190 -421 190 l-118 0 0
-356z m326 281 c67 -20 117 -64 151 -133 24 -50 28 -69 28 -147 0 -78 -4 -97
-28 -147 -55 -112 -129 -148 -304 -148 l-113 0 0 288 c0 159 3 292 7 295 13
13 209 7 259 -8z"/>
<path d="M4133 1876 c-196 -64 -291 -297 -203 -500 29 -68 100 -139 172 -171
54 -24 70 -27 137 -23 128 7 222 74 280 197 23 49 26 69 26 156 0 87 -3 107
-27 157 -33 70 -103 143 -166 170 -58 26 -162 33 -219 14z m192 -70 c58 -26
109 -80 138 -145 31 -67 30 -189 -1 -256 -48 -106 -133 -165 -237 -165 -103 0
-186 55 -235 156 -35 70 -35 196 -1 272 27 60 106 137 155 151 58 17 128 12
181 -13z"/>
<path d="M4744 1872 c4 -11 69 -170 146 -354 134 -323 140 -333 168 -336 l28
-3 143 343 c79 189 146 349 148 356 4 8 -6 12 -29 12 l-34 0 -123 -305 c-68
-168 -127 -307 -130 -309 -4 -3 -63 134 -131 302 l-125 307 -33 3 c-30 3 -33
1 -28 -16z"/>
<path d="M5827 1883 c-3 -4 -61 -143 -130 -308 -69 -165 -135 -322 -146 -348
l-21 -48 37 3 c36 3 36 3 81 111 l45 107 162 0 162 0 44 -107 c42 -104 45
-108 77 -111 17 -2 32 1 32 5 0 5 -64 164 -143 353 -133 320 -145 345 -169
348 -14 2 -28 0 -31 -5z m104 -257 c37 -91 65 -167 61 -170 -7 -8 -282 -8
-282 0 0 4 78 197 125 308 9 21 19 35 22 32 4 -4 37 -80 74 -170z"/>
<path d="M6400 1536 l0 -356 240 0 240 0 0 30 0 30 -205 0 -205 0 -2 323 -3
322 -32 3 -33 3 0 -355z"/>
<path d="M2760 885 c0 -12 14 -15 70 -15 l70 0 0 -185 c0 -178 1 -185 20 -185
19 0 20 7 20 185 l0 185 70 0 c56 0 70 3 70 15 0 13 -24 15 -160 15 -136 0
-160 -2 -160 -15z"/>
<path d="M3260 700 l0 -200 135 0 c113 0 135 2 135 15 0 12 -19 15 -115 15
l-115 0 0 80 0 80 100 0 c82 0 100 3 100 15 0 12 -18 15 -100 15 l-100 0 0 75
0 75 110 0 c91 0 110 3 110 15 0 13 -21 15 -130 15 l-130 0 0 -200z"/>
<path d="M3780 743 c-111 -268 -103 -243 -81 -243 14 0 26 17 44 63 l25 62 93
3 94 3 24 -61 c21 -56 43 -81 57 -67 3 3 -31 92 -75 198 -59 144 -84 195 -98
197 -15 2 -30 -28 -83 -155z m124 19 c20 -48 36 -91 36 -95 0 -4 -36 -7 -81
-7 -44 0 -79 3 -77 8 2 4 19 47 38 95 19 48 38 87 41 87 3 0 23 -40 43 -88z"/>
<path d="M4220 700 c0 -192 1 -200 20 -200 18 0 20 8 22 163 l3 162 70 -123
c44 -78 74 -122 83 -120 8 2 47 59 86 128 l71 125 3 -168 c2 -139 5 -167 17
-167 13 0 15 30 15 200 0 253 -4 255 -109 70 -40 -72 -77 -132 -81 -135 -4 -3
-42 56 -85 130 -57 101 -81 135 -96 135 -18 0 -19 -9 -19 -200z"/>
<path d="M660 670 l0 -70 998 2 997 3 3 68 3 67 -1001 0 -1000 0 0 -70z"/>
<path d="M4760 670 l0 -70 1060 0 1060 0 0 70 0 70 -1060 0 -1060 0 0 -70z"/>
</g>
</svg>


export default sandovalTeamIcon;